<template>
  <v-autocomplete
      class="reg-normal text-primary mt-3"
      base-color="border-tertiary"
      bg-color="secondary"
      density="default"
      :label="$store.getters.translate('tags')"
      v-model="new_value"
      :items="tags"
      :disabled="isDisabled"
      item-value="name.en"
      item-title="name.en"
      :return-object="false"
      :menu="false"
      menu-icon=""
      chips
      single-line
      :closable-chips="!isDisabled"
      hide-details
      :multiple="!single"
      :clearable="!isDisabled">
    <template v-if="!isDisabled" #append-inner>
      <v-icon @click.stop="load();$refs['tags_' + modal_name].open();" color="primary" size="large" icon="mdi-tag"/>
    </template>
  </v-autocomplete>
    <base-draggable-modal
        :name="'tags_' + modal_name"
        max-height="80vh"
        width="50vw"
        :fullscreen="$vuetify.display.xsOnly"
        :ref="'tags_' + modal_name">
      <v-card rounded="xl">
        <base-modal>
          <template #header>
            <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
              <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
            </v-toolbar>
          </template>
          <template #content>
            <v-card-text>
              <v-data-table
                  :headers="headers"
                  :items="tags"
                  class="elevation-1"
                  v-bind="footer_props"
                  :show-select="false">
                <template #body="{ items }">
                  <tr v-for="item in items" :key="item.id" class="sm-normal text-primary">
                    <td>{{ $store.getters.translate(item.name.en) }}</td>
                    <td>{{ moment(item.updated_at).format("DD-MM-YYYY hh:mm") }}</td>
                    <!--ACTION BUTTONS-->
                    <td style="text-align: center; width: 80px;" v-if="canDelete">
                      <v-menu>
                        <template #activator="{ props }">
                          <v-btn elevation="0" icon v-bind="props">
                            <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-if="canDelete" @click="deleteRecord(item.id)">
                            <template #prepend><PhTrash size="24"/></template>
                            <v-list-item-title class="sm-normal link ml-2">{{ $store.getters.translate('delete') }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-text-field
                  class="reg-normal text-primary mt-5"
                  base-color="border-tertiary"
                  bg-color="secondary"
                  v-model="record.name"
                  :disabled="!canCreate"
                  append-inner-icon="mdi-plus"
                  @click:append-inner="save()"
                  :label="$store.getters.translate('create')"
                  single-line
                  hide-details
                  flat
                  clearable/>
            </v-card-text>
          </template>
          <template #footer>
            <v-card-text>
              <v-row>
                <v-col class="text-center">
                  <base-action-button :width="'50%'" @action="$refs['tags_' + modal_name].close()">
                    <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                    {{ $store.getters.translate("cancel") }}
                  </base-action-button>
                </v-col>
              </v-row>
            </v-card-text>
          </template>
        </base-modal>
      </v-card>
    </base-draggable-modal>
</template>

<script>
import {useAbility} from "@casl/vue";
import helpFunctions from "../../plugins/helpFunctions";
import BaseModal from "./BaseModal";
import BaseDraggableModal from "./BaseDraggableModal";
import BaseActionButton from "./BaseActionButton";
import {PhDotsThreeVertical, PhTrash, PhX} from "@phosphor-icons/vue";

export default {
  props: ["modelValue", "modal_name", "single", "available_tags", "isDisabled"],
  components: { BaseActionButton, BaseModal, BaseDraggableModal, PhX, PhTrash, PhDotsThreeVertical },
  setup: function() {
    const { can } = useAbility();
    return { can }
  },
  data() {
    return {
      page: helpFunctions.pages.tags,
      new_value: [],
      tags: [],
      record: {},
      headers: [
        { title: this.$store.getters.translate("name"), align: "start", sortable: true, value: "name.en" },
        { title: this.$store.getters.translate("updated_at"), align: "start", sortable: true, value: "updated_at" },
        { title: "", align: "center", sortable: false, value: "actions", "width": "80px" },
      ],
      footer_props: helpFunctions.footer_props,
    };
  },
  created() {
    this.new_value = this.modelValue;
    if(this.available_tags && this.available_tags.length > 0) {
      this.tags = this.available_tags;
    }
    else {
      this.load();
    }
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load() {
      this.tags = await helpFunctions.getFullAdditionalModels(this.$toast, "tag", false);
    },
    async save() {
      let usual_fields_required = [{name: 'name', mandatory: true}];
      if (helpFunctions.modelFieldsFilled(this.$toast, this.record, usual_fields_required)) {
        if (await helpFunctions.createModel(this.$toast, this.page.name, this.record)) {
          this.record = {};
          this.$refs['tags_' + this.modal_name].close();
          await this.load();
        }
      }
    },
    async deleteRecord(id) {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, id);
          await this.load();
        }
      });
    },
  },
  computed: {
    canCreate() {
      return this.can("create", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
    canDelete() {
      return this.can("delete", this.$createEntity(this.page.model.toLowerCase(), { id: 0 }));
    },
  },
  watch: {
    new_value: {
      handler() {
        this.$emit('change', this.new_value);
      },
    },
    modelValue: {
      handler() {
        this.new_value = this.modelValue;
      },
    },
    available_tags: {
      handler() {
        if(this.available_tags.length > 0) {
          this.tags = this.available_tags;
        }
        else {
          this.load();
        }
      },
    },
  },
};
</script>